import { render, staticRenderFns } from "./IcoSettings.vue?vue&type=template&id=6a2a2802&scoped=true"
import script from "./IcoSettings.vue?vue&type=script&lang=js"
export * from "./IcoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2a2802",
  null
  
)

export default component.exports